document.addEventListener( 'DOMContentLoaded', function () {
	const bioButtons = document.querySelectorAll( '.full-bio' );
	// Exit early if no .full-bio elements are found
	if ( bioButtons.length === 0 ) return;	
	bioButtons.forEach( function ( button ) {
		button.addEventListener( 'click', function () {
			const userBlock = this.closest( '.user-section' );
			userBlock.classList.toggle( 'active' );

			const textSpan = this.querySelector( '.full-bio-text' );
			const iconSpan = this.querySelector( '.full-bio-icon' );

			if ( userBlock.classList.contains( 'active' ) ) {
				textSpan.textContent = 'Full Bio';
				iconSpan.textContent = ' ×';
			} else {
				textSpan.textContent = 'Full Bio';
				iconSpan.textContent = ' →';
			}
		} );
	} );
} );
